import React from "react";
import { HiOutlineSparkles } from "react-icons/hi";

const TimesheetAiAnalyzeButton = ({
  disabled,
  loading,
  onClick,
  hidden = false,
  compact = false,
}) => {
  if (hidden) return null;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
      className={`inline-flex h-9 shrink-0 items-center justify-center gap-1.5 rounded-[10px] border px-3 text-sm font-semibold transition-colors sm:gap-2 sm:px-3.5 ${
        disabled || loading
          ? "cursor-not-allowed border-gray-200 bg-gray-100 text-gray-400"
          : "border-[#4B6CB7] bg-[#ECF0FD] text-[#4B6CB7] hover:bg-[#4B6CB7]/10"
      }`}
    >
      {loading ? (
        <span className="inline-block h-4 w-4 rounded-full border-2 border-blue-200 border-t-[#4B6CB7] animate-spin" />
      ) : (
        <HiOutlineSparkles className="h-4 w-4 shrink-0" />
      )}
      <span className="whitespace-nowrap">
        {compact ? (
          <>
            <span className="timesheet-bulk-toolbar__label-short">Analyse</span>
            <span className="timesheet-bulk-toolbar__label-full">Analyse with AI</span>
          </>
        ) : (
          "Analyse with AI"
        )}
      </span>
    </button>
  );
};

export default TimesheetAiAnalyzeButton;
